<template>
  <div>
    <TheBanner />

    <div class="c-wallet-with-shopping container">
      <WalletHolidayNotice
        :visibleRanges="[
          {
            start: new Date('2025-06-16T03:00:00.000Z'), // 16/06/2025 00:00
            end: new Date('2025-06-20T02:59:59.999Z'), // 19/06/2025 23:59
          }
        ]"
      />

      <div class="columns is-gapless">
        <div class="column is-4">
          <TheBannerBonus class="is-hidden-tablet" />
          <TheWalletValuesSummary />
          <CardDepositMoney
            v-if="walletSummary.wallet.settings.add_credit_from_pix"
            @open-modal-deposit-money="openModal"
          />
        </div>
        <div class="column is-hidden-mobile">
          <TheBannerBonus />
          <WalletLastTransactions />
        </div>
      </div>
    </div>

    <ModalDepositMoney ref="modelDepositMoney" />
  </div>
</template>

<script>
import CardDepositMoney from '@/components/Wallet/CardDepositMoney.vue'
import TheBanner from '@/components/Wallet/Index/Banners/TheBannerShopping.vue'
import TheWalletValuesSummary from '@/components/Wallet/Index/TheWalletValuesSummary.vue'
import ModalDepositMoney from '@/components/Wallet/ModalDepositMoney.vue'
import TheBannerBonus from '@/components/Wallet/WalletBannerBonus.vue'
import WalletLastTransactions from '@/components/Wallet/WalletLastTransactions.vue'

import WalletHolidayNotice from '@/components/Wallet/WalletHolidayNotice.vue'

export default {
  components: {
    TheWalletValuesSummary,
    WalletLastTransactions,
    TheBannerBonus,
    TheBanner,
    ModalDepositMoney,
    CardDepositMoney,
    WalletHolidayNotice,
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
  },

  methods: {
    openModal() {
      this.$refs.modelDepositMoney.open()
    },
  },
}
</script>

<style lang="scss">
.layout {
  position: relative;
  background-color: $gray-1;

  @media (min-width: $mobile) {
    background-color: transparent;

    &:before {
      @include position(absolute, auto, 0, 0, 0);
      content: '';
      width: 33.3333333333%;
      height: 100%;
      z-index: -1;
      background-color: $gray-1;
    }
  }
}
</style>
